//Interface

export interface RegisterLoginData{
    phoneNumber : string
    email : string
    password : string
    confirmPassword : string
    smsOTP : string
    whatsappOTP : string
    emailOTP : string
    emailValidationNotice : boolean
    phoneValidationNotice : boolean
    passwordValidationNotice : boolean
    confirmPasswordValidationNotice : boolean
    show : boolean
    signType : number
    isShowCaptcha : boolean
    captcha : string
    captchaImg : string
    showSMSOTP : boolean
    showEmailOTP : boolean
    showWhatsappOTP : boolean
    cloudFlareCaptchaEnabled : boolean
    cloudFlareSiteKey : string
    sliderEnabled: boolean
    isRegisterBtnActive: boolean,
    isLoginBtnActive: boolean,
    isLoading: boolean
} 

// Constant

export const COUNT_DOWN_TIME = 60


// Functions

export const callOtpMethod = (
  otpRef: any,
  method: 'loadingFalse' | 'startCountdown'
): void => {
  otpRef?.value?.[method]?.()
}

export const startCountdown = (
  refs: { sms?: any; whatsapp?: any; email?: any },
  type: 'sms' | 'whatsapp' | 'email'
): void => {
  const refMap = {
    sms: refs.sms,
    whatsapp: refs.whatsapp,
    email: refs.email
  }
  callOtpMethod(refMap[type], 'startCountdown')
}

export const stopLoading = (
  refs: { sms?: any; whatsapp?: any; email?: any },
  type: 'sms' | 'whatsapp' | 'email'
): void => {
  const refMap = {
    sms: refs.sms,
    whatsapp: refs.whatsapp,
    email: refs.email
  }
  callOtpMethod(refMap[type], 'loadingFalse')
}

export const startCountdownCommon = (
  countdown: { value: number },
  isCounting: { value: boolean }
): (() => void) => {
  let timer: ReturnType<typeof setInterval> | null = null

  countdown.value = 60
  isCounting.value = true

  timer = setInterval(() => {
    if (countdown.value > 1) {
      countdown.value--
    } else {
      clearInterval(timer!)
      timer = null
      isCounting.value = false
    }
  }, 1000)

  return () => {
    if (timer) {
      clearInterval(timer)
      timer = null
      isCounting.value = false
    }
  }
}